import { MerchantAddress } from "@/model/merchant/merchantAddress";

export function ConvertToMerchantDetail(detail: any) {
  return detail;
}

export function ConvertToMerchantAddressList(addressListRaw: any): Array<MerchantAddress> {
  const addressList = new Array<MerchantAddress>();
  if (addressListRaw && addressListRaw.length > 0) {
    for (const addressItem of addressListRaw) {
      const address: MerchantAddress = {
        addressName: addressItem.addressName,
        building: addressItem.building,
        country: addressItem.country,
        district1: addressItem.district1,
        district2: addressItem.district2,
        floorNo: addressItem.floorNo,
        homeGroup: addressItem.homeGroup,
        homeNo: addressItem.homeNo,
        id: addressItem.id,
        language: addressItem.language,
        name: addressItem.name,
        no: addressItem.no,
        postCode: addressItem.postCode,
        province: addressItem.province,
        road: addressItem.road,
        roomNo: addressItem.roomNo,
        soi: addressItem.soi,
      };
      addressList.push(address);
    }
  }
  return addressList;
}
